import React, { useState } from 'react';

const upcomingEvents = [
  { id: 1, title: 'Greater Metro Chamber of Commerce 2025', date: 'March 15th, 2025', tag: 'Business' },
  { id: 2, title: 'Wednesday Potluck Networking Dinner',    date: 'March 20th, 2025', tag: 'Social'   },
  { id: 3, title: 'Annual Innovation Summit 2025',          date: 'April 5th, 2025',  tag: 'Conference'},
];

const showcaseEvents = [
  { title: 'Spring Showcase Expo',  date: 'May 12, 2025', spots: 8  },
  { title: 'Innovation Demo Day',   date: 'Jun 3, 2025',  spots: 3  },
  { title: 'Startup Pitch Night',   date: 'Jun 20, 2025', spots: 12 },
];

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const ListRow = ({ children }) => (
  <div className="flex justspacebetween aligncenter p-t-10 p-b-10 br-btm-grey">{children}</div>
);

const GreenBtn = ({ label = 'View', onClick, extraClass = '' }) => (
  <button className={`btn-primary bg-green1-dark text-white brd-5 font-12 fw500 p-5-10 ${extraClass}`} onClick={onClick}>
    {label}
  </button>
);

const EventsTab = () => {
  const [regStates, setRegStates] = useState({ 0: false, 1: true, 2: false });

  return (
    <>
      <SectionCard>
        <CardHeader title="Upcoming Events" action="Filter" />
        {upcomingEvents.map((ev, i) => (
          <ListRow key={i}>
            <div className="flex aligncenter gap-15 flex-grow">
              <div className="icon-circle-box flex aligncenter justifycenter flex-shrink brd-10 bg-blue-white">
                <i className="fas fa-calendar highlight font-18"></i>
              </div>
              <div>
                <div className="fw500 font-14 dark-navy">{ev.title}</div>
                <div className="font-12 lgrey m-t-2">
                  {ev.date}
                  <span className="badge-3 bg-pale-green color-green1-dark m-l-10">{ev.tag}</span>
                </div>
              </div>
            </div>
            <GreenBtn />
          </ListRow>
        ))}
      </SectionCard>

      <SectionCard>
        <CardHeader title="Showcase Event Registration" action="View All" />
        {showcaseEvents.map((ev, i) => (
          <ListRow key={i}>
            <div>
              <div className="fw500 font-14 dark-navy">{ev.title}</div>
              <div className="font-12 lgrey m-t-2">
                {ev.date} &bull;&nbsp;
                <span className={`fw500 ${ev.spots <= 5 ? 'red' : 'green'}`}>{ev.spots} spots left</span>
              </div>
            </div>
            <button
              className={`btn-primary brd-5 font-12 fw500 p-5-10 text-white ${regStates[i] ? 'bg-cancel' : 'bg-green1-dark'}`}
              onClick={() => setRegStates(s => ({ ...s, [i]: !s[i] }))}>
              {regStates[i] ? 'Unregister' : 'Register'}
            </button>
          </ListRow>
        ))}
      </SectionCard>
    </>
  );
};

export default EventsTab;